<template>
  <iColumn align="center">
    <iSubHeading
      variant="standard"
      class="setup-heading"
    >
      Let's get you set up. Enter your details below
    </iSubHeading>
    <iText v-if="signUpNote" data-test="deleted-account-sign-up-note">
      {{ signUpNote }}
    </iText>
    <iTextInput
      v-model="userAuthEmail"
      placeholder="Email"
      disabled
      width="fill"
      right-icon="pencil"
      class="email-input"
      :padding-right-multiplier="3"
      @click-icon-right="goBackToEmailStep"
    />
    <iTextInput
      v-model="firstName"
      placeholder="First Name"
      width="fill"
      focus
    />
    <iTextInput
      v-model="lastName"
      placeholder="Last Name"
      width="fill"
    />
    <iTextInput
      v-model="password"
      placeholder="Password"
      width="fill"
      type="password"
    />
    <PasswordComplexity
      v-if="password"
      :password="password"
      @update:password="validatePasswordComplexity"
    />
    <iTextInput
      v-model="confirmPassword"
      placeholder="Confirm Password"
      width="fill"
      type="password"
      @enter="completeSignUp"
    />
    <iText v-if="signupErrorMessage" variant="error">
      {{ signupErrorMessage }}
    </iText>
    <iButton
      :is-loading="isLoading"
      loading-spinner-position="inside"
      :disabled="isLoading || !validPassword || !isSignupFormValid"
      @click="completeSignUp"
    >
      Continue
    </iButton>
    <iSpace :height="20" width="fill" />
    <PoweredByInspiration />
  </iColumn>
</template>

<script>
import PoweredByInspiration from "@/components/join-publication/PoweredByInspiration";
import { mapActions, mapState, mapWritableState } from "pinia";
import PasswordComplexity from "@/components/PasswordComplexity.vue";
import { useUserStore } from "~/stores/user-store";

export default {
  name: "JoinPublicationSignUp",
  components: { PasswordComplexity, PoweredByInspiration },
  data() {
    return {
      validPassword: false,
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
    };
  },
  computed: {
    ...mapWritableState(useUserStore, [
      "userAuthEmail",
      "userFlowSteps",
      "signupErrorMessage",
    ]),
    ...mapState(useUserStore, [
      "signUpNote",
      "isLoading",
    ]),
    isSignupFormValid() {
      return this.validateSignupFormData(
        this.firstName,
        this.lastName,
        this.userAuthEmail,
        this.password,
        this.confirmPassword,
      );
    },
  },
  mounted() {
    this.signupErrorMessage = "";
  },
  methods: {
    ...mapActions(useUserStore, [
      "signUpUser",
      "validateSignupFormData",
    ]),
    completeSignUp() {
      if (!this.isSignupFormValid) {
        return;
      }
      this.signUpUser(this.firstName, this.lastName, this.userAuthEmail, this.password, 1);
    },
    goBackToEmailStep() {
      this.userFlowSteps.pop();
    },
    validatePasswordComplexity(value) {
      this.validPassword = value;
    },
  },
};
</script>

<style scoped lang="scss">
.setup-heading {
  text-align: center;
}

.email-input :deep(.icon-right svg) {
  fill: #5b5a63;
  color: #5b5a63;
}

.email-input :deep(.icon-right .i-icon:hover) {
  opacity: 1;
}
</style>
